import React, {ReactNode} from 'react';
import {View} from 'react-native';
import './BrightenIcon.css';
import {styles} from './styles';

export const BrightenIcon: React.FC<{children: ReactNode}> = props => {
  return (
    <div className="brighten-icon-container pulse">
      <View style={styles.MenuItemProfilAvatar}>{props.children}</View>
    </div>
  );
};
